import { useContext } from 'react';

import { AppContext } from '../AppContext';

export const useUserSelector = () => {
  const { user } = useContext(AppContext);
  return user;
};
